import React, { Fragment } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';

const PolicyText = dynamic(() => import('../../components/Legal/PolicyText'), {
  loading: () => 'Loading...',
});

export default function Policy() {  

  return (
    <main>
      <Head>
        <title>Monet</title>
        <meta name="description" content="Privacy Policy - Introduction - Definitions - Collection of personal data
        -  Network and Information Security - Questions"/>
      </Head>
      <Fragment>
        <PolicyText />
      </Fragment>
    </main>
  );
}